<div class="container mt-30">
  <nav class="nav nav-secondary">
    <!--Account-->
    <a
      class="nav-item"
      [routerLink]="['/account']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'account.nav.account.screenreader' | translate: { fgbdefault: 'Move to Account page' } }}"
    >
      <span>{{ 'account.nav.profile' | translate }}</span>
    </a>
    <a
      class="nav-item"
      [routerLink]="['/membership']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'account.nav.membership.screenreader' | translate: { fgbdefault: 'Move to membership page' } }}"
    >
      <span>{{ 'account.nav.membership' | translate }}</span>
    </a>
    <a
      class="nav-item"
      [routerLink]="['/benefits']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'account.nav.benefits.screenreader' | translate: { fgbdefault: 'Move to benefits page' } }}"
    >
      <span>{{ 'account.nav.benefits' | translate }}</span>
    </a>
  </nav>
</div>
